export default __webpack_public_path__ + "static/media/IMG_4519.5dc26344.jpg";